module.exports = __webpack_public_path__ + "static/media/directspeech.b0ca8531.svg";